import { Users } from "lucide-react";

export function UserMealFormServings({ form, updateNumberField }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <label className="block text-sm font-medium text-gray-900 mb-2">
        Servings *
      </label>
      <div className="relative">
        <Users className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="number"
          value={form.servings || ""}
          onChange={(e) => updateNumberField("servings", e.target.value)}
          placeholder="4"
          required
          min="1"
          className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
        />
      </div>
    </div>
  );
}
